// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.spotlight.RentalManagerUserPropertySpotlightWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  BulkListingSpotlightRequestDto,
  CustomerListingSpotlightOptimizationConfigDto,
  GetSpotlightedListingsResponseDto,
  GetUserPropertySpotlightOverviewResponseDto,
  ListingAlias,
  ListingSpotlightUpdateResultDto,
  SetOptimizationModeRequestDto,
  SetSmartConfigModeRequestDto,
} from '../..';

interface ApplyParams {
  listingAlias: ListingAlias;
}
interface ExcludeParams {
  listingAlias: ListingAlias;
}
interface PinParams {
  listingAlias: ListingAlias;
}
interface ReassignParams {
  fromListingAlias: ListingAlias;
  toListingAlias: ListingAlias;
}
interface ReassignWithOptimizationParams {
  fromListingAlias: ListingAlias;
  toListingAlias: ListingAlias;
}
interface RemoveParams {
  listingAlias: ListingAlias;
}
interface UnexcludeParams {
  listingAlias: ListingAlias;
}
interface UnpinParams {
  listingAlias: ListingAlias;
}

export const RentalManagerUserPropertySpotlightWebApiHandler_apply_Path =
  '/api/web/v1/users/properties/spotlight/apply';

/**
 * Apply listing spotlight
 * @deprecated
 */
export const RentalManagerUserPropertySpotlightWebApiHandler_apply = (getParams: ApplyParams, client = getClient()) => {
  return httpFrontEndRequest<ApplyParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertySpotlightWebApiHandler_apply_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertySpotlightWebApiHandler_exclude_Path =
  '/api/web/v1/users/properties/spotlight/exclude';

/**
 * Exclude listing spotlight
 * @deprecated
 */
export const RentalManagerUserPropertySpotlightWebApiHandler_exclude = (
  getParams: ExcludeParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<ExcludeParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertySpotlightWebApiHandler_exclude_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertySpotlightWebApiHandler_excludeListings_Path =
  '/api/web/v1/users/properties/spotlight/excludeListings';

/**
 * Exclude listing spotlight for listings
 */
export const RentalManagerUserPropertySpotlightWebApiHandler_excludeListings = (
  postData: BulkListingSpotlightRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, BulkListingSpotlightRequestDto, Array<ListingSpotlightUpdateResultDto>>(
    {
      endpoint: RentalManagerUserPropertySpotlightWebApiHandler_excludeListings_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertySpotlightWebApiHandler_getOptimizationConfig_Path =
  '/api/web/v1/users/properties/spotlight/getOptimizationConfig';

/**
 * Get optimization config for spotlight
 */
export const RentalManagerUserPropertySpotlightWebApiHandler_getOptimizationConfig = (client = getClient()) => {
  return httpFrontEndRequest<never, never, CustomerListingSpotlightOptimizationConfigDto>(
    {
      endpoint: RentalManagerUserPropertySpotlightWebApiHandler_getOptimizationConfig_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertySpotlightWebApiHandler_list_Path = '/api/web/v1/users/properties/spotlight/list';

/**
 * Get listings with spotlight promotion
 */
export const RentalManagerUserPropertySpotlightWebApiHandler_list = (client = getClient()) => {
  return httpFrontEndRequest<never, never, GetSpotlightedListingsResponseDto>(
    {
      endpoint: RentalManagerUserPropertySpotlightWebApiHandler_list_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertySpotlightWebApiHandler_overview_Path =
  '/api/web/v1/users/properties/spotlight/overview';

/**
 * Get spotlight overview for user properties
 */
export const RentalManagerUserPropertySpotlightWebApiHandler_overview = (client = getClient()) => {
  return httpFrontEndRequest<never, never, GetUserPropertySpotlightOverviewResponseDto>(
    {
      endpoint: RentalManagerUserPropertySpotlightWebApiHandler_overview_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertySpotlightWebApiHandler_pin_Path = '/api/web/v1/users/properties/spotlight/pin';

/**
 * Pin listing spotlight
 * @deprecated
 */
export const RentalManagerUserPropertySpotlightWebApiHandler_pin = (getParams: PinParams, client = getClient()) => {
  return httpFrontEndRequest<PinParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertySpotlightWebApiHandler_pin_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertySpotlightWebApiHandler_pinListings_Path =
  '/api/web/v1/users/properties/spotlight/pinListings';

/**
 * Pin listing spotlight for listings
 */
export const RentalManagerUserPropertySpotlightWebApiHandler_pinListings = (
  postData: BulkListingSpotlightRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, BulkListingSpotlightRequestDto, Array<ListingSpotlightUpdateResultDto>>(
    {
      endpoint: RentalManagerUserPropertySpotlightWebApiHandler_pinListings_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertySpotlightWebApiHandler_reassign_Path =
  '/api/web/v1/users/properties/spotlight/reassign';

/**
 * Reassign listing spotlight
 * @deprecated
 */
export const RentalManagerUserPropertySpotlightWebApiHandler_reassign = (
  getParams: ReassignParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<ReassignParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertySpotlightWebApiHandler_reassign_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertySpotlightWebApiHandler_reassignWithOptimization_Path =
  '/api/web/v1/users/properties/spotlight/reassignWithOptimization';

/**
 * Reassign listing spotlight with optimization
 * @deprecated
 */
export const RentalManagerUserPropertySpotlightWebApiHandler_reassignWithOptimization = (
  getParams: ReassignWithOptimizationParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<ReassignWithOptimizationParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertySpotlightWebApiHandler_reassignWithOptimization_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertySpotlightWebApiHandler_remove_Path =
  '/api/web/v1/users/properties/spotlight/remove';

/**
 * Remove listing spotlight
 * @deprecated
 */
export const RentalManagerUserPropertySpotlightWebApiHandler_remove = (
  getParams: RemoveParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<RemoveParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertySpotlightWebApiHandler_remove_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertySpotlightWebApiHandler_setOptimizationMode_Path =
  '/api/web/v1/users/properties/spotlight/setOptimizationMode';

/**
 * Set optimization mode for spotlight
 */
export const RentalManagerUserPropertySpotlightWebApiHandler_setOptimizationMode = (
  postData: SetOptimizationModeRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SetOptimizationModeRequestDto, void>(
    {
      endpoint: RentalManagerUserPropertySpotlightWebApiHandler_setOptimizationMode_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertySpotlightWebApiHandler_setSmartConfigMode_Path =
  '/api/web/v1/users/properties/spotlight/setSmartConfigMode';

/**
 * Set smart config mode for spotlight
 */
export const RentalManagerUserPropertySpotlightWebApiHandler_setSmartConfigMode = (
  postData: SetSmartConfigModeRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SetSmartConfigModeRequestDto, void>(
    {
      endpoint: RentalManagerUserPropertySpotlightWebApiHandler_setSmartConfigMode_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertySpotlightWebApiHandler_unexclude_Path =
  '/api/web/v1/users/properties/spotlight/unexclude';

/**
 * Unexclude listing spotlight
 * @deprecated
 */
export const RentalManagerUserPropertySpotlightWebApiHandler_unexclude = (
  getParams: UnexcludeParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<UnexcludeParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertySpotlightWebApiHandler_unexclude_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertySpotlightWebApiHandler_unexcludeListings_Path =
  '/api/web/v1/users/properties/spotlight/unexcludeListings';

/**
 * Unexclude listing spotlight for listings
 */
export const RentalManagerUserPropertySpotlightWebApiHandler_unexcludeListings = (
  postData: BulkListingSpotlightRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, BulkListingSpotlightRequestDto, Array<ListingSpotlightUpdateResultDto>>(
    {
      endpoint: RentalManagerUserPropertySpotlightWebApiHandler_unexcludeListings_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertySpotlightWebApiHandler_unpin_Path =
  '/api/web/v1/users/properties/spotlight/unpin';

/**
 * Unpin listing spotlight
 * @deprecated
 */
export const RentalManagerUserPropertySpotlightWebApiHandler_unpin = (getParams: UnpinParams, client = getClient()) => {
  return httpFrontEndRequest<UnpinParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertySpotlightWebApiHandler_unpin_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertySpotlightWebApiHandler_unpinListings_Path =
  '/api/web/v1/users/properties/spotlight/unpinListings';

/**
 * Unpin listing spotlight for listings
 */
export const RentalManagerUserPropertySpotlightWebApiHandler_unpinListings = (
  postData: BulkListingSpotlightRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, BulkListingSpotlightRequestDto, Array<ListingSpotlightUpdateResultDto>>(
    {
      endpoint: RentalManagerUserPropertySpotlightWebApiHandler_unpinListings_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
